import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormInput } from 'common/components/form';

const FinancierProductName = ({ control, disabled }) => {
    const { t } = useTranslation();
    return (
        <ReactHookFormInput
            key="financier_product_name"
            control={control}
            disabled={disabled}
            label={t('Product type id')}
            name="financier_product_name"
        />
    );
};

FinancierProductName.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
};

export default FinancierProductName;
